import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { localDocumentDto } from '../../types/localDoment-dto'

export const localDocumentsApiRtk = createApi({
  reducerPath: 'localDocumentsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (build) => ({
    getLocalDocument: build.query<localDocumentDto, { documentType: string; lang?: string }>({
      query: ({ documentType, lang = 'en' }) => `legalDocuments/${lang}/${documentType}.json`,
    }),
  }),
})

export const { useGetLocalDocumentQuery } = localDocumentsApiRtk
